import { takeLatest, put, call, select } from 'redux-saga/effects';
import { formatYear } from '../../helpers/numberOperations';
import ApiCall from './ApiCall';
import CaseTransformer from '../../helpers/CaseTransformer';

// Keys the applicant cannot fix on the form: a failure on these is a broken
// session, so it must keep showing the "System Error" screen.
const SYSTEM_FIELDS = ['uuid'];

// A 422 with a `message` object is a field validation failure, not a system
// error: surface it on the form instead of the "System Error" screen.
const getValidationErrors = (data = {}) => {
  const { code, message } = data;
  if (code !== 422 || typeof message !== 'object' || message === null) return null;
  const errors = CaseTransformer.keysToCamel(message);
  const entries = Object.entries(errors)
    .filter(([field]) => !SYSTEM_FIELDS.includes(field))
    .map(([field, messages]) => [
      field,
      Array.isArray(messages) ? messages[0] : messages,
    ]);
  return entries.length ? Object.fromEntries(entries) : null;
};

function* ApiResponse({ payload }) {
  try {
    const { UserIdData = {} } = yield select();
    const { uuid = 0 } = UserIdData;
    const values = { ...payload };
    values.year = formatYear(payload.year);
    const formattedValues = CaseTransformer.keysToSnake(values);

    yield put({ type: 'CLEAR_VALIDATION_ERRORS', payload: {} });

    yield call(() =>
      ApiCall('/application/detailsStep', { ...formattedValues, uuid })
    );
    yield put({
      type: 'CHANGE_SCREEN',
      payload: {
        link: '/address',
        form: 'mailing-address',
      },
    });
  } catch (e) {
    const data = (e.response && e.response.data) || {};
    const validationErrors = getValidationErrors(data);

    yield put({
      type: validationErrors ? 'API_VALIDATION_REJECTED' : 'API_REJECTED',
      payload: { ...data, validationErrors },
    });
    yield put({
      type: 'DISABLE_SPINNER',
      payload: data,
    });
    yield put({
      type: 'CANCEL_SUBMIT',
      payload: data,
    });
  }
}

function* watchLastFetchUser() {
  yield takeLatest('GET_APPLICANT_DATA', ApiResponse);
}

export default watchLastFetchUser;
